import { Language } from 'client/graphql/types/operations';

export const isLanguage = (value: unknown): value is Language => {
  return (
    typeof value === 'string' &&
    (Object.values(Language) as string[]).includes(value)
  );
};
